<template>
    <div class="flex flex-row">
        <div class="flex flex-col justify-center pr-1">
            <slot />
        </div>

        <div class="h-[calc(100%-0.5rem)] w-px bg-gray-300 my-1" />

        <div class="flex flex-col p-1 min-w-min-content justify-center text-center px-1 gap-2">
            <div class="ml-1">
                <div class="text-2xl/none font-bold tabular-nums">{{ props.sum }}</div>
                <div class="font-light text-sm/tight text-gray-600">{{ $t('occupied-federal-states') }}</div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
type FederalStatesDotsTileProps = {
    sum: number;
};

const props = defineProps<FederalStatesDotsTileProps>();
</script>
